<template>
  <div style="padding: 20px 40px 40px 40px;">
    <FormsListener
      v-if="activateFormsListener"
      collection="users"
      :userID="userJSON.id"
      @forms-real-time="formsRealTime"
    />
    <Header
      title="Forms"
      smallTitle="Configuration"
      @buttonClick="showNewFormModal"
      buttonName="Create New"
    />
    <b-row style="margin: 0px;">
      <template v-for="(form, index) in formsArray">
        <CardForm :form="form" :userJSON="userJSON" :key="index" />
      </template>
    </b-row>
    <!-- Content here -->
    <!--   Create new form -->
    <div>
      <b-modal id="newFormModal" hide-footer ref="newFormModalRef">
        <template v-slot:modal-title>New Form</template>
        <div>Select type:</div>
        <b-form-select v-model="formTypeSelected" :options="formTypes"></b-form-select>
        <CustomFormGroup
          label="Enter the name of the form"
          :inputTag="0"
          @update-input="getTextInputData"
        />
        <CustomFormGroup
          label="Enter a description"
          :inputTag="1"
          @update-input="getTextInputData"
        />
        <b-button
          v-if="formTypeSelected && everythingOK"
          @click="createNewForm"
          variant="outline-primary"
          style="float: right;"
        >Create</b-button>
      </b-modal>
    </div>
  </div>
</template>
<script>
// Components
import Header from "@/components/Header.vue";
import CardForm from "./components/CardForm.vue";
import CustomFormGroup from "../../components/CustomFormGroup.vue";
import FormsListener from "@/connection/FormsListener.vue";
// External functions
import { functionsDB } from "@/connection/connection.js";
// Libraries
import Vue from "vue";
import VueSwal from "vue-swal";

Vue.use(VueSwal);

export default {
  name: "Forms",
  components: {
    Header,
    CardForm,
    CustomFormGroup,
    FormsListener
  },
  props: {
    userJSON: {}
  },
  data() {
    return {
      formTypeSelected: null,
      formTypes: [
        { value: null, text: "Please select an option" },
        { value: "visitor", text: "Visitor" },
        { value: "regular", text: "Regular Form", disabled: true }
      ],
      dataChecker: null,
      formsArray: [],
      inputFormArray: [
        {
          value: "",
          state: null
        },
        {
          value: "",
          state: null
        }
      ],
      everythingOK: false,
      activateFormsListener: false
    };
  },
  methods: {
    formsRealTime(formsArray) {
      this.formsArray = formsArray;
    },
    getTextInputData(data) {
      this.inputFormArray[data.index].value = data.value;
      this.inputFormArray[data.index].state = data.state;
      // checks all states to allow button
      var generalState = true;
      for (let index = 0; index < this.inputFormArray.length; index++) {
        const element = this.inputFormArray[index];
        if (!element.state) {
          generalState = false;
          break;
        }
      }
      this.everythingOK = generalState;
    },
    alertSuccess() {
      this.$swal({
        title: "Perfect!",
        text: "The operation was successful.",
        icon: "success"
      });
    },
    alertError() {
      this.$swal({
        title: "Something went wrong!",
        text: "Please try again",
        icon: "error"
      });
    },
    async createNewForm() {
      var formJSON = {
        type: this.formTypeSelected,
        name: this.inputFormArray[0].value,
        description: this.inputFormArray[1].value
      };

      var wasFormWritten = await functionsDB.writeNewForm(
        "users",
        this.userJSON.id,
        formJSON
      );
      if ((wasFormWritten = "yes")) {
        this.$refs["newFormModalRef"].hide();
        this.alertSuccess();
      } else this.alertError();
    },
    showNewFormModal() {
      this.formTypeSelected = null;
      this.$refs["newFormModalRef"].show();
    }
  },
  async mounted() {
    // Start page code
    this.activateFormsListener = true;
  }
};
</script>